// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"b459150a","768":"52ba9de0"}[chunkId] + ".chunk.css";
};